<template>
  <div class="footer_box">
    <div class="footer">
      <span>
        Copyright© 1998-{{new Date().getFullYear()}} DRCnet.com.cn All Rights Reserved
        (建议浏览器：ie9+、火狐、谷歌)
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang='less' scoped>
.footer {
  background: url(../assets/imgs/footer-bj.jpg) no-repeat center;
  height: 60px;
}
.footer span {
  text-align: center;
  margin: 0 auto;
  line-height: 60px;
  display: block;
}
.footer_box {
  background: url(../assets/imgs/f_bj.jpg) repeat-x center;
  height: 60px;
  margin-top: 15px;
}
</style>